import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  jobData: localStorage.getItem('jobData')
    ? JSON.parse(localStorage.getItem('jobData'))
    : null,
};

const jobSlice = createSlice({
  name: 'job',
  initialState,
  reducers: {
    setJobData: (state, action) => {
      state.jobData = action.payload;
      localStorage.setItem('jobData', JSON.stringify(action.payload));
    },
    removeJobData: (state, action) => {
      state.jobData = null;
      localStorage.removeItem('jobData');
    },
  },
});

export const { removeJobData, setJobData } = jobSlice.actions;

export default jobSlice.reducer;